import React, { useState } from 'react';
import { EventCoupon } from 'utils/shared/money/calculateEventOrderTotal';
import CloseIcon from 'svg/CloseIcon';
import { Button } from 'components/Button';
import Pill from 'components/Pill';

interface Props {
  appliedCoupon: EventCoupon | null;
  onApply: (code: string) => void;
  onClear: () => void;
  isLoading?: boolean;
  error?: string | null;
}

export default function DiscountCode({ appliedCoupon, onApply, onClear, isLoading, error }: Props) {
  const [code, setCode] = useState('');

  const handleSubmit = () => {
    if (code.trim()) {
      onApply(code.trim());
    }
  };

  const handleClear = () => {
    setCode('');
    onClear();
  };

  const showClearButton = !!appliedCoupon || !!error;

  return (
    <div className="flex flex-col gap-1">
      <label className="typography-product-element-label text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        Use discount code
      </label>
      <div className="flex items-center gap-3">
        <div className="relative flex-1">
          <input
            type="text"
            value={appliedCoupon ? appliedCoupon.code : code}
            onChange={appliedCoupon ? undefined : (e) => setCode(e.target.value)}
            disabled={!!appliedCoupon}
            placeholder="Code"
            className="input-form w-full pr-10"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && code.trim()) {
                e.preventDefault();
                handleSubmit();
              }
            }}
          />
          {showClearButton && (
            <button
              type="button"
              onClick={handleClear}
              className="absolute right-3 top-1/2 -translate-y-1/2"
            >
              <CloseIcon className="h-5 w-5 text-color-text-lightmode-tertiary dark:text-color-text-darkmode-tertiary" />
            </button>
          )}
        </div>
        {appliedCoupon ? (
          <Pill type="success" text="Applied" />
        ) : error ? (
          <Pill type="critical" text="Invalid" />
        ) : (
          <Button
            onClick={handleSubmit}
            variant="secondary"
            size="md"
            isInline
            disabled={isLoading || !code.trim()}
            loading={isLoading}
            className="shrink-0 !rounded-full"
          >
            Apply
          </Button>
        )}
      </div>
    </div>
  );
}
